import 'arrive';
import $ from 'jquery';

document.arrive('#wpadminbar', {existing: true}, function() {
    var hiddenBar = false;

    document.addEventListener('keydown', (e) => {
        if(e.key == '*') {
            $('#wpadminbar').css('display', hiddenBar ? 'block' : 'none');
            $('html').toggleClass('no-admin-bar');
            hiddenBar = !hiddenBar;
        }
    });
})

document.addEventListener('DOMContentLoaded', (event) => {

    const checkNavbar = () => {
        if (window.scrollY > 0 ) {
            document.getElementById('site-header').classList.add('sticky');
        } else {
            document.getElementById('site-header').classList.remove('sticky');
        }
    }

    checkNavbar();

    document.addEventListener('scroll', checkNavbar);

});

document.arrive('.toggle_megamenu', {existing: true}, function() {
    var hiddenBar = false;
    $('html').addClass('no-admin-bar');
    $('#wpadminbar').css('display', 'none');

    $(this).click(() => {
        if (document.getElementById('site-header').classList.contains('open'))
        {
            document.getElementById('site-header').classList.remove('open')
            document.getElementsByTagName("html")[0].style.overflow = '';
        }
        else
        {
            document.getElementById('site-header').classList.add('open')
            document.getElementsByTagName("html")[0].style.overflow = 'hidden';
        }
    });

})